import { getAnimationSessionId } from './animation.selectors'

export const getAnimationBySessionId = (animations, sessionId) =>
  (animations || []).find(animation => getAnimationSessionId(animation) === sessionId)
